import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AssetResource} from '../../../../../class/lifeproject/asset-resource';
import {AbstractAsset} from '../../../../../class/abstract-asset';

@Component({
  selector: 'app-asset-resource-row',
  templateUrl: './asset-resource-row.component.html',
  styleUrls: ['./asset-resource-row.component.css']
})
export class AssetResourceRowComponent implements OnInit {

  @Input()
  assetResource: AbstractAsset;

  @Output()
  selectedAsset = new EventEmitter<AbstractAsset>();

  constructor() {
  }

  ngOnInit() {

  }

  onItemClick() {
    this.selectedAsset.emit(this.assetResource);
  }

}
